
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component({
    components: {
    }
  })

  export default class General extends Vue  {
    dialog = false
    generalDialog = false
    editDateMenu = false
    menu = false
    lastBIR = null
    nextBIR = null
    expanded = []
    inspectedItems = [
      { text: 'LA County', value: 'LA County' },
      { text: 'Caltrans', value: 'Caltrans' },
      { text: 'City', value: 'City' },
      { text: 'Consultant', value: 'Consultant' },
    ]
    headers = [
      { text: 'Date', value: 'date' },
      { text: 'Deck', value: 'deck' },
      { text: 'Super', value: 'superStructure' },
      { text: 'Sub', value: 'subStructure' },
      { text: 'Culvert', value: 'culvert' },
      { text: 'Structure (FKA Channel)', value: 'channel' },
      { text: 'Scour', value: 'scourCritical' },
      { text: 'Sufficiency', value: 'sufficiencyRating' },
      //{ text: 'URL', value: 'url' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]
    items: Array<object> = []
    generalItem: any = {
      frequency: null,
      nextBIR: null,
      lastBIR: null,
      id: -1
    }
    editedIndex = -1
    editedItem: any = {
      id: null,
      date: null,
      user: '',
      sufficiencyRating: null,
      deck: null,
      superStructure: null,
      subStructure: null,
      channel: '',
      inspectedBy: '',
      culvert: '',
      scourCritical: '',
      paintCondition: '',
      recommendedRepairs: '',
      tags: [],
      url: '',
      pdf: null,
      bridgeId: -1
    }
    defaultItem: any = {
      id: null,
      date: null,
      user: '',
      sufficiencyRating: null,
      deck: null,
      superStructure: null,
      subStructure: null,
      channel: '',
      inspectedBy: '',
      culvert: '',
      scourCritical: '',
      paintCondition: '',
      recommendedRepairs: '',
      url: '',
      pdf: null,
      bridgeId: -1
    }
    rating: any = [
      { text: 'N N/A NBI', value: -1 },
      { text: '0 Failed', value: 0 },
      { text: '1 Imminent Failure', value: 1 },
      { text: '2 Critical', value: 2 },
      { text: '3 Serious', value: 3 },
      { text: '4 Poor', value: 4 },
      { text: '5 Fair', value: 5 },
      { text: '6 Satisfactory', value: 6 },
      { text: '7 Good', value: 7 },
      { text: '8 Very Good', value: 8 },
      { text: '9 Excellent', value: 9 },
    ]
    ratingCulvert: any = [
      { text: 'N N/A NBI', value: -1 },
      { text: '0 Failed', value: 0 },
      { text: '1 Imminent Failure', value: 1 },
      { text: '2 Critical', value: 2 },
      { text: '3 Serious', value: 3 },
      { text: '4 Poor', value: 4 },
      { text: '5 Fair', value: 5 },
      { text: '6 Deterioration', value: 6 },
      { text: '7 Minor Deterioration', value: 7 },
      { text: '8 No Major Problem', value: 8 },
      { text: '9 Excellent', value: 9 },
    ]
    ratingChannel: any = [
      { text: 'N N/A NBI', value: -1 },
      { text: '0 Failed', value: 0 },
      { text: '1 Imminent Failure', value: 1 },
      { text: '2 Critical', value: 2 },
      { text: '3 Serious', value: 3 },
      { text: '4 Min Tolerable', value: 4 },
      { text: '5 Above Min Tolerable', value: 5 },
      { text: '6 Equal Min Criteria', value: 6 },
      { text: '7 Above Min Criteria', value: 7 },
      { text: '8 Protected', value: 8 },
      { text: '9 No Deficiencies', value: 9 },
    ]
    ratingScour: any = [
      { text: 'Unknown', value: -2 },
      { text: 'N Not over Waterway', value: -3 },
      { text: '0 Failed', value: 0 },
      { text: '1 Imminent Failure', value: 1 },
      { text: '2 Critical', value: 2 },
      { text: '3 Serious', value: 3 },
      { text: '4 Poor', value: 4 },
      { text: '5 Stable w/in Footing', value: 5 },
      { text: '6 Calcs Not Made', value: 6 },
      { text: '7 Good', value: 7 },
      { text: '8 Stable Above Footing', value: 8 },
      { text: '9 Excellent', value: 9 },
    ]
    tags: any = [
      { text: 'A-Joint', value: 'Seal A-Joint Seal' },
      { text: 'B-Joint', value: 'Seal B-Joint Seal' },
      { text: 'Abutment', value: 'Abutment' },
      { text: 'Bolts/Screws', value: 'Bolts/Screws' },
      { text: 'Deck Drains', value: 'Deck Drains' },
      { text: 'Guardrail', value: 'Guardrail' },
      { text: 'Pier Nose', value: 'Pier Nose' },
      { text: 'Railing', value: 'Railing' },
      { text: 'Seal Deck', value: 'Seal Deck' },
      { text: 'Streambed', value: 'Vegetation Streambed Vegetation' },
      { text: 'Striping', value: 'Striping' },
      { text: 'Spalled Concrete', value: 'Spalled Concrete' },
      { text: 'Spalled Joints', value: 'Spalled Joints' },
    ]
    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public editGeneral(): void {
      this.generalDialog = true
    }

    public saveGeneral(): void {
      this.$store.dispatch('bridge/saveBridgeInspectionGeneral', this.generalItem)
      this.generalDialog = false

    }

    public addNewReport(): void {
      this.dialog = true
    }

    public editItem(item: object ): void {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }

    public close(): void {
      this.dialog = false
      this.$store.commit('bridge/setMsg', "")
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }

    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridgeInspectionReport', item)
    }

    public download(item: object): void {
      this.$store.dispatch('bridge/downloadBridgeInspectionReport', item)
    }

    public viewPDF(item: object): void {
      this.$store.dispatch('bridge/openBridgeInspectionReportPDF', item)
    }

    public save(): void {
      this.editedItem.bridgeId = this.id
      if (this.editedIndex > -1) {
        this.$store.dispatch('bridge/updateBridgeInspectionReport', this.editedItem)
        //Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.$store.dispatch('bridge/storeBridgeInspectionReport', this.editedItem)
        //this.items.push(this.editedItem)
      }
      this.close()
    }

    //Getters
    get getNextBIR(): any {
      return this.nextBIR
    }
    get getBridgeInspectionReports(): any {
      return this.$store.getters['bridge/getBridgeInspectionReports']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 6) {
        this.$store.dispatch('bridge/getBridgeInspectionReports', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgeInspectionReports')
    setItems(val: any) {
      val.bridge_inspection_reports.forEach(bir => {
        bir.tags = []
        bir.bridge_inspection_report_tags.forEach(tag => {
          bir.tags.push(tag.name) 
        });
      });
      this.items = val.bridge_inspection_reports
      this.lastBIR = val.lastBIR
      this.nextBIR = val.nextBIR
      Object.assign(this.generalItem, val.general) //Possibly should be added to the rest of the assigns
    }
  }



